import { Avatar } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { MapPin, Mail, Phone, Share2 } from "lucide-react";
import { UserProfile } from "@/types/user";

interface ProfileHeaderProps {
  provider: UserProfile;
}

export function ProfileHeader({ provider }: ProfileHeaderProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-6">
        <Avatar className="h-24 w-24">
          <div className="bg-blue-600 w-full h-full flex items-center justify-center text-white text-2xl">
            {provider.email?.charAt(0).toUpperCase()}
          </div>
        </Avatar>
        <div className="flex-1">
          <h1 className="text-2xl font-bold">{provider.name || provider.email}</h1>
          <p className="text-gray-600">{provider.role}</p>
          <div className="mt-4 flex gap-2">
            <Button variant="outline" size="sm">
              Entrar em Contato
            </Button>
            <Button variant="ghost" size="sm">
              <Share2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-gray-600">
            <MapPin className="h-5 w-5" />
            <span>{provider.address}</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600">
            <Mail className="h-5 w-5" />
            <span>{provider.email}</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600">
            <Phone className="h-5 w-5" />
            <span>{provider.phone}</span>
          </div>
        </div>
        <div>
          <h3 className="font-semibold mb-2">Sobre</h3>
          <p className="text-gray-600">{provider.description}</p>
        </div>
      </div>
    </div>
  );
}